import APP_ROUTES, {
  ADMIN_ROUTES,
  BROADCAST_ROUTES,
  LIBRARY_ROUTES,
  REPORT_ROUTES,
} from 'routes/app';
import clsx from 'clsx';
import { NavLink } from 'react-router-dom';
import logo from 'assets/images/cosbots-logo.png';
import { useAuthentication } from 'hooks/AuthenticationHook';
import React from 'react';
import iMonitorLogo from 'assets/images/imonitor-2.png';

import { EVENTS_ROUTES } from 'routes/app';

const buildSidebarSections = (isVenueManagerUser) => {
  // Venue managers (musical-event-manager role) should only see EVENTS & REPORTING
  if (isVenueManagerUser) {
    return [['EVENTS & REPORTING', EVENTS_ROUTES]];
  }
  // Regular users see all menu sections
  return [
    ['DASHBOARD', APP_ROUTES],
    ['MONITORING', BROADCAST_ROUTES],
    ['LIBRARY', LIBRARY_ROUTES],
    ['CHARTS & REPORTS', REPORT_ROUTES],
    ['ADMINISTRATION', ADMIN_ROUTES],
    ['EVENTS & REPORTING', EVENTS_ROUTES],
  ];
};

export default function Sidebar() {
  let { logout, isVenueManager } = useAuthentication();
  const isVenueManagerUser = isVenueManager();
  // Debug: log role detection (remove in production)
  if (process.env.NODE_ENV === 'development') {
    console.log('Sidebar - isVenueManager:', isVenueManagerUser);
  }
  const sideBarSection = buildSidebarSections(isVenueManagerUser);

  return (
    <div className="flex flex-col flex-grow border-r border-gray-200 pt-1 pb-0 border-gray-200 overflow-y-auto bg-white">
      <div className="flex items-center">
        <img
          className="h-12 w-auto px-12 m-4 mt-5"
          src={logo}
          alt="SABC logo"
        />
      </div>
      <div className="mt-5 flex-grow flex flex-col">
        <nav className="flex-1 space-y-1" aria-label="Sidebar">
          {sideBarSection.map(([sectionHeading, sectionRoutes], index) => (
            <React.Fragment key={sectionHeading + index}>
              <div className="mt-0 pt-2 ">
                <div className="px-2 space-y-1">
                  <span className="text-blue-500 font-normal text-xs ml-3">
                    {sectionHeading}
                  </span>
                </div>
              </div>

              {sectionRoutes.map((item, index) => {
                return item.sidebar ? (
                  <NavLink
                    key={item.name + index}
                    to={item.link}
                    exact={item.name === 'Home'}
                    activeClassName={
                      'bg-sabc-blue border-sabc-blue font-bold text-white border-l-4'
                    }
                    className={
                      'border-transparent hover:bg-sabc-blue hover:text-white flex items-center px-3 py-2 text-md font-light border-l-4'
                    }
                  >
                    <item.icon
                      className={clsx('mr-3 flex-shrink-0 h-6 w-6 stroke-1', {
                        'text-white group-hover:text-white':
                          item.current === false,
                      })}
                      aria-hidden="true"
                    />
                    {item.name}
                  </NavLink>
                ) : (
                  <React.Fragment key={item.name + index}></React.Fragment>
                );
              })}
            </React.Fragment>
          ))}
        </nav>
      </div>
      <div className="flex-shrink-0 flex border-t-2 border-gray-100 p-3">
        <div className="flex-shrink-0 w-full group block">
          <div className="flex items-center">
            <img className="h-11 ml-5" src={iMonitorLogo} alt="iMonitor" />
          </div>
        </div>
      </div>
    </div>
  );
}
